import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Order  {
    _originalTypeClassName = "ekylikeio.BO.Order";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Order.translate = translateService;
}
this.orderToOrderItem = [];
this.Id = null;
this.Date = null;
this.OrderStatus = null;
this.Notes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
OrderStatus:any;
Notes:any;
orderToOrderItem:any;
orderToPayment:any;
CreatedBy:any;
static setorderToOrderItem = ($this, items) => {
                if (items == null) items = [];
                if ($this.orderToOrderItem == null) $this.orderToOrderItem = [];

                const copyItems = Common.cloneObject(items);

                while ($this.orderToOrderItem.length > 0) {
                    Domain.Order.removeorderToOrderItem($this, $this.orderToOrderItem[0]);
                }

                Domain.Order.addManyorderToOrderItem($this, copyItems);
            }
static addManyorderToOrderItem = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Order.addorderToOrderItem($this, items[i]);
                }
            }
static addorderToOrderItem = ($this, item) => {
                if ($this.orderToOrderItem == null) $this.orderToOrderItem = [];
                if (item == null || $this.orderToOrderItem.indexOf(item) > -1) return;
                $this.orderToOrderItem.push(item);
}
static addRangeorderToOrderItem = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Order.addorderToOrderItem($this, item));
            }
static removeorderToOrderItem = ($this, item) => {
                if ($this == null || $this.orderToOrderItem == null || $this.orderToOrderItem.indexOf(item) === -1) return;
                var _index = $this.orderToOrderItem.indexOf(item);
                $this.orderToOrderItem.splice(_index, 1);
}
static clearorderToOrderItem = ($this) => { $this.orderToOrderItem = null; }
static setorderToPayment = ($this, value) => {
var oldValue = $this.orderToPayment;
$this.orderToPayment = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}

static GetActiveOrder(): any{let user = Joove.Common.cast(window._context.currentUser, "Domain.UserAcount");
if (user == null) {return null;}
if (user?.ActiveOrder == null) {Domain.UserAcount.setActiveOrder(user, new Domain.Order());Domain.Order.setCreatedBy(user.ActiveOrder, user);user.ActiveOrder.OrderStatus = Domain.OrderStatus.New;Domain.Order.setorderToPayment(user.ActiveOrder, new Domain.Payment());user.ActiveOrder.Date = moment().toDate();}
return user?.ActiveOrder;
}
static UpdateTotalPrice($this: any): any{for (let _iitem = 0; _iitem < ($this?.orderToOrderItem == null ? 0 : $this?.orderToOrderItem.length); _iitem++) {let item = $this?.orderToOrderItem[_iitem];Domain.OrderItem.UpdatePrice(item);}
$this.orderToPayment.Amount = $this?.orderToOrderItem?.linq?.sum((s) => s?.TotalPrice);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}